import React, {useState} from 'react';
// import {Button, ButtonToolbar, Modal, Input, ModalHeader} from "reactstrap";
import {Button, Modal, Input, TextField, MenuItem, Box,} from "@mui/material";
import { categorizeNewsAPI} from "../../../apis/my_service";
import {Typography} from "antd";
import styles from "../../../assets/styles/modules/AddCategory.module.css";
const style = {
    position: 'absolute',
    top: '20%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    outline: 0,
};
const AddCategoryModal = ({categoryBtnList, modalOpen, setModalOpen, addOrMove, scrapeidx, addBtnClick}) => {


    const [category, setCategory] = useState('')
    const selectCategory = (e) => setCategory(e.target.value)

    const categorizeNews = () => {
        const targetCategory = categoryBtnList.filter(el => el.categoryid === category)
        const categoryId = targetCategory[0].categoryid

        scrapeidx && scrapeidx.map((idx)=> categorizeNewsAPI(idx, categoryId).then(res => {console.log(res)}))
        addBtnClick('add', false)
        setTimeout(()=> { window.location.reload()}, 500)
    }


    return (
        // <Modal id='categoryModal' isOpen={categoryModal} toggle={addBtnClick}>
        // <Modal id='categoryModal' open={modalOpen} onClose={()=>addBtnClick(false)}>
        //     <div onClick={addBtnClick}>
        //         <h4 className="text-modal modal__title" style={{whiteSpace: 'pre-wrap'}}>
        //             { addOrMove === 'add' ? '뉴스를 카테고리에 추가하시겠습니까?' : '뉴스를 이동하시겠습니까?'}
        //         </h4>
        //     </div>
        //     <div className="modal__header">
        //         <Input type='select' onChange={selectCategory}>
        //             <option value=''/>
        //             {categoryBtnList && categoryBtnList.map((el)=> <option key={el.categoryid} value={el.categoryid}>{el.categoryname}</option>)}
        //         </Input>
        //     </div>
        //     {/*<ButtonToolbar className="modal__footer" style={{justifyContent: 'center'}}>*/}
        //         <Button className="modal_ok" outline='false' style={{width: '158px', height: '40px', margin: '1px'}} onClick={categorizeNews}>
        //             { addOrMove === 'add' ? '추가하기' : '이동하기'}
        //         </Button>
        //         <Button className="modal_ok" outline='false' style={{width: '150px', height: '40px', margin: '1px'}} onClick={addBtnClick}>
        //             닫기
        //         </Button>
        //     {/*</ButtonToolbar>*/}
        // </Modal>

        <Modal open={modalOpen} onClose={() => addBtnClick('add', false)}>
            <Box sx={style}>
                <Typography className={styles.modal_title}>{addOrMove === 'add' ? '뉴스를 카테고리에 추가하시겠습니까?' : '뉴스를 이동하시겠습니까?'}</Typography>
                <TextField select className={styles.category_select_input} onChange={selectCategory}>
                    <MenuItem value=''/>
                    {categoryBtnList && categoryBtnList.map((el)=> <MenuItem key={el.categoryid} value={el.categoryid}>{el.categoryname}</MenuItem>)}
                </TextField>
                <div className={styles.btn_container_bookmark}>
                    <Button className="modal_ok" variant='contained' style={{width: '158px', height: '40px', margin: '1px'}} onClick={categorizeNews}>
                        { addOrMove === 'add' ? '추가하기' : '이동하기'}
                    </Button>
                    <Button className="modal_ok" variant='outlined' style={{width: '150px', height: '40px', margin: '1px'}} onClick={addBtnClick}>
                        닫기
                    </Button>
                </div>

            </Box>
        </Modal>
    )
}

export default AddCategoryModal;